import React from 'react';
import './style.css';
import StoreInfoComponent from "../components/StoreInfo/StoreInfoComponent";

const StoreInfoPage = () => (
  <StoreInfoComponent/>
);

export default StoreInfoPage;